<template>
  <div>

    <div class="project cp" v-on:click="openProject($event)" :style="{'background-image' : 'url(' + project.background + ')'}">
      <div class="video" :style="{'background-image' : 'url(' + project.background + ')'}" >
      <div v-if="project.vr360 == 0" v-on:click="playPause" class="pause"></div>
        <div class="player" >
          <div id="dots-loader" class="dots-loading-container">
              <div class="dot dot-a"></div>
              <div class="dot dot-b"></div>
              <div class="dot dot-c"></div>
              <div class="dot dot-d"></div>
          </div>
          <span class="volume">
          VOLUME
          <div class="range-slider">
            <input v-on:change="getVolume" class="range-slider__range" :id="'volume' + project.id" type="range" value="8" min="0" max="10">
          </div>
        </span>
        <span class="timeline">
          TIMELINE
          <div class="range-slider">
            <input v-on:change="getTimeline" class="range-slider__range" :id="'timeline' + project.id" type="range" value="0">
          </div>
        </span>
        <div class="player_video_inside" :id="project.vimeo_id"  data-vimeo-defer> </div>
        </div>
        <span class="close" v-on:click.stop.prevent="closeProject($event)"><img src="../assets/close_btn.png" alt="CLOSE"></span>
        
        <div class="panel-right panel-video" style="right: 0">
          <h3>{{ project.title }}</h3>
          <span class="keyword">{{ project.keywords }}</span>
          <br><br>
          <p v-html="project.description"></p>
          <a v-on:click="playPause" class="link">
            <img src="../assets/play_btn.png" alt=""> 
          </a>
        </div>
      </div>
      <div class="clip-mask">
          <div class="background-mask" :style="{'background-image' : 'url(' + project.background + ')'}" ></div>
      </div>
      <div class="panel-right panel-project">
        <h3>{{ project.title }}</h3>
        <span class="keyword">{{ project.keywords }}</span>
        <a v-on:click="openProject($event)" class="link">
          <img src="../assets/play_btn.png" alt=""> 
        </a>
      </div>
    </div>
    
  </div>
</template>

<script>
import $ from 'jquery'
import Player from '@vimeo/player';


export default {
  name: 'Project',
  props: ['projectObj'],
  data () {
    return {
      project: this.projectObj,
      player: null,
      current: false,
    }
  },
  methods: {
    openProject(e){
      var el = $('#'+this.project.vimeo_id).parents('.project').find('.video')
      var that = this
      el = $(el).parents('.project').find('.video')
      var player_element = document.getElementById(this.project.vimeo_id)
      $(el).css('transform', 'scaleY(1)')

      if (this.project.vr360 == 1) {
         var options = {
          id: this.project.vimeo_id, 
          responsive: 1,
          portrait : true,  
          loop: true,
          muted: false,
          playsinline:false,
          quality: 1080
        }

      } else {
        var options = {
            id: this.project.vimeo_id, 
            responsive: 1,
            portrait : true,  
            background: true,
            loop: true,
            muted: false,
            playsinline:false,
            quality: 720
        }
      }
        

     
      this.current = true;
      this.player = new Player(player_element, options);

      // this.player.getDuration().then(function(duration) {
      //     $('.timeline input').attr('max', duration)
      //     $('.timeline input').attr('step', parseFloat(duration/100))
      // }).catch(function(error) {
      //     // an error occurred
      // });
        this.player.on('play', function() {
            $(el).find('.panel-video').css('right','-50%')
            $(el).find('.panel-video .link img').css('transform','rotate(180deg)')

        });
      
      this.player.on('timeupdate', function(time) {
          $('.timeline input').val(time.seconds)
        });
      this.player.on('pause', function() {
            $(el).find('.panel-video').css('right','0%')
            $(el).find('.panel-video .link img').css('transform','rotate(0deg)')
        });

      var that = this
      $(document).keyup(function(e) {
        if (e.keyCode === 27) that.closeProject() 
        if (e.keyCode === 32) that.playPause()  
        if (e.keyCode === 38) that.updateVolume('++')  
        if (e.keyCode === 39) that.updateTimeline('++')  
        if (e.keyCode === 37) that.updateTimeline('--')  
        if (e.keyCode === 40) that.updateVolume('--')  
      });

      this.player.getDuration().then(function(duration) {
          $('.timeline input').attr('max', duration)
          $('.timeline input').attr('step', parseFloat(duration/100))
      }).catch(function(error) {
          // an error occurred
      });

      that.getVolume()

      

    },
    closeProject(e){
      console.log('close')
      var el = $('#'+this.project.vimeo_id).parents('.project').find('.video')
      this.player.pause()
      this.current = false
      el = $(el).parents('.project').find('.video')
      $(el).css('transform', 'scaleY(0)')
    },
    pause() {
      this.player.pause()
    },
    playPause() {
      var that = this
        var el = $('#'+that.project.vimeo_id).parents('.project').find('.video')

         if ($(el).find('.panel-video').css('right') != "0px") {
            $(el).find('.panel-video').css('right','0%')

          }else {
            $(el).find('.panel-video').css('right','-50%')
            
          }
          if (this.current == true) {
             this.player.getPaused().then(function(paused) {
                  if (paused) {
                    that.player.play()
                  } else {
                    that.player.pause()
                  }
              }).catch(function(error) {
                  console.log('error')

              });
          }
     
    },
    setVolume(Vol) {
      
      this.player.setVolume(Vol).then(function(volume) {
        console.log('volume updated : ', volume)
      }).catch(function(error) {
          switch (error.name) {
              case 'RangeError':
                  console.log('the volume was less than 0 or greater than 1')
                  break;

              default:
                  console.log('some other error occurred')
                  break;
          }
      });
    }, 
    getVolume() {
      var slider = $('.volume .range-slider')
      var range = $('.volume .range-slider__range#volume'+this.project.id)

          var value = $(range).val();
          value = value/10
      this.setVolume(value)
      return value;
    }, 
    updateVolume(sens) {
      var range = $('.volume .range-slider__range#volume'+this.project.id)

      if (sens == "++") {

          var value = $(range).val();
          var newVal = parseInt(value)+1
          $(range).val(newVal);

          value = newVal/10
          
          this.setVolume(value)

      this.setVolume(value)

      } else if( sens == '--') {

          var value = $(range).val();
          var newVal = parseInt(value)-1
          $(range).val(newVal);

          value = newVal/10
          
          this.setVolume(value)
      }
    },
    setTimeline(time) {

      this.player.setCurrentTime(time).then(function(time) {
        console.log('time updated : ', time)

        var range = $('.timeline .range-slider__range#timeline'+this.project.id)
        var value = $(range).val(time);

      
      }).catch(function(error) {
          switch (error.name) {
              case 'RangeError':
                  console.log('the time was less or greater than timeline')
                  break;

              default:
                  console.log('some other error occurred')
                  break;
          }
      });
    }, 
    getTimeline() {
      var slider = $('.timeline .range-slider')
      var range = $('.timeline .range-slider__range#timeline'+this.project.id)

      var value = $(range).val();

      this.setTimeline(value)

    }, 
    updateTimeline(sens) {
      var range = $('.timeline .range-slider__range#timeline'+this.project.id)

      if (sens == "++") {

          var value = $(range).val();
          var newVal = parseFloat(value)+parseFloat($(range).attr('step'))
          $(range).val(newVal);

          value = newVal
          console.log(value)
          
          this.setTimeline(value)

      } else if( sens == '--') {

          var value = $(range).val();
          var newVal = parseFloat(value)-parseFloat($(range).attr('step'))
          $(range).val(newVal);

          value = newVal
          console.log(value)
          
          this.setTimeline(value)
      }
    },
    

  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.project {
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
  background-size: contain; /* CALER SUR LA HAUTER */
  background-size: cover; /* CALER SUR LA LARGEUR */
  background-position: center;
  background-repeat: no-repeat;
}
.video {
  background: #000;
  position: fixed;
  height: 100vh;
  top: 0; left: 0;
  width: 100%;
  transform: scaleY(0);
  transform-origin: center;
  z-index: 200;
  overflow: hidden;
  transition-duration: .3s;
  background-size: cover;
  background-repeat: no-repeat;

}

.video .close {
  position: fixed;
  top: 10px; right: 10px;
  z-index: 254;
  color: #fff;
}
.video .player { width: 100%; height: 100%;background: #000 }

.clip-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  /*background-color: yellow;*/
  clip: rect(0, auto, auto, 0);
}
.background-mask {
    /*clip-path: url('#myClip');*/
    mask-image: url('../assets/logo.svg');
    mask-position: center;
    mask-repeat: no-repeat;
    mask-size: 285px;
    background-attachment: fixed;
    background-size: contain;
    background-position: center center;
    height: 285px;
    width: 285px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
     -webkit-filter: blur(15px);
    -moz-filter: blur(15px);
    -o-filter: blur(15px);
    -ms-filter: blur(15px);
    filter: blur(15px);
}

.panel-right {
  position: absolute;
  right: -100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
  color: #fff;
  text-align: right;
  width: 20%;
  padding: 0 5%;
  transition-duration: .5s;

}

.project:hover .panel-project {
  right: 0;
  transition-duration: .5s;
}

.panel-right h3{
  font-weight: 100;
  font-size: 1.5em;
  margin: 150px 0 10px;
}
.panel-right .keyword {
  font-weight: 100;
  text-transform: uppercase;
  background: #000;
  padding: 2px 10px;
  font-size: 1.1em;
}

.panel-right .link{
  position: absolute;
  cursor: pointer;
  left: 0;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  border-radius: 100%;
  border: 2px solid #fff;
  /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#000000+0,000000+100&0.65+50,0.5+50,0+51 */
background: -moz-linear-gradient(left, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.5) 49.5%, rgba(0,0,0,0) 50%, rgba(0,0,0,0) 100%); /* FF3.6-15 */
background: -webkit-linear-gradient(left, rgba(0,0,0,0.5) 0%,rgba(0,0,0,0.5) 49.5%,rgba(0,0,0,0) 50%,rgba(0,0,0,0) 100%); /* Chrome10-25,Safari5.1-6 */
background: linear-gradient(to right, rgba(0,0,0,0.5) 0%,rgba(0,0,0,0.5) 49.5%,rgba(0,0,0,0) 50%,rgba(0,0,0,0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#80000000', endColorstr='#00000000',GradientType=1 ); /* IE6-9 */
}

.panel-right .link:hover img { 
  transform: rotate(360deg);  
}
.panel-right .link img {
  transition-duration: .5s;
}

.panel-video { width: 40%; z-index: 203;position: absolute;top: 0;right: 0;}
.video .panel-video { z-index: 230;}
.panel-video h3 { font-size: 2.5em; }
.panel-video .keyword { 
  font-size: 1.8em; 
  padding: 4px 15px;
}
.panel-video p { 
  width: 70%;
  float: right;
  text-align: justify;
}
.panel-video p:after { 
  content: "";
  display: block;
  height: 2px;
  background: #fff;
  width: 75%;
  float: right;
  margin: 40px 0;
}
.player_video_inside {
    top: 50%;
    position: relative;
    transform: translateY(-50%);
}

.volume {
  position: absolute;
  bottom: 40px;
  left: calc(30px - 100px);
  z-index: 210;
  width: 200px;
  transform: rotate(-90deg);
  color: #fff;
  text-align: right;
  letter-spacing: 4px;
  font-size: 10px;
}

.timeline {
  position: absolute;
  bottom: 10px;
  left:  10%;
  right:  10%;
  z-index: 210;
  color: #fff;
  text-align: right;
  letter-spacing: 4px;
  font-size: 10px;

}

.range-slider {
  width: 100%;
}

.range-slider__range {
  -webkit-appearance: none;
  width: calc(100% - (73px));
  height: 2px;
  border-radius: 2px;
  background: #FFF;
  outline: none;
  padding: 0;
  margin: 0;
}
.range-slider__range::-webkit-slider-thumb {
  -webkit-appearance: none;
          appearance: none;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #FFF;
  cursor: pointer;
  -webkit-transition: background .15s ease-in-out;
  transition: background .15s ease-in-out;
}
.range-slider__range::-webkit-slider-thumb:hover {
  background: #DDD;
}
.range-slider__range:active::-webkit-slider-thumb {
  background: #DDD;
}
.range-slider__range::-moz-range-thumb {
  width: 10px;
  height: 10px;
  border: 0;
  border-radius: 50%;
  background: #FFF;
  cursor: pointer;
  -webkit-transition: background .15s ease-in-out;
  transition: background .15s ease-in-out;
}
.range-slider__range::-moz-range-thumb:hover {
  background: #DDD;
}
.range-slider__range:active::-moz-range-thumb {
  background: #DDD;
}

::-moz-range-track {
  background: #FFF;
  border: 0;
}

input::-moz-focus-inner,
input::-moz-focus-outer {
  border: 0;
}

.pause {
  position: fixed;
  top: 0;bottom: 0;right: 0;left: 0;
  z-index: 201;
}
.cp { cursor: pointer; }


@media screen and (max-width: 640px) { 
  
  .panel-right {
    width: 65%;
    padding-right: 20%;
    right: -100%;
  }
  .project { height: 130px; }
  .video { overflow-y: scroll; }
 .video .player { width: 100%; height: auto; position: relative;}

  .video .panel-right {
    width: 90%;
    min-height: 70%;
    padding: 5%;
    right: 0;
    height: auto;
    position: relative;
  }

  .volume { top: 100px;bottom: initial; }
  .player_video_inside {
    top: 0%;
    position: relative;
    transform: translateY(0%);
  }
  .panel-right h3{
    margin-top: 40px;
  }
  
}

.dots-loading-container{width:66px;-webkit-animation:expand .75s ease-in-out infinite alternate;-moz-animation:expand .75s ease-in-out infinite alternate;-ms-animation:expand .75s ease-in-out infinite alternate;animation:expand .75s ease-in-out infinite alternate;top:50%;left:50%;margin-left:-33px;margin-top:30px;position:absolute}.dot{width:13px;height:13px;border-radius:50%;position:absolute;}.dot.dot-a{-webkit-animation:scaleA 1.5s ease-in-out infinite;-moz-animation:scaleA 1.5s ease-in-out infinite;-ms-animation:scaleA 1.5s ease-in-out infinite;animation:scaleA 1.5s ease-in-out infinite;background-color:#fff;left:0%}.dot.dot-b{-webkit-animation:scaleB 1.5s ease-in-out infinite;-moz-animation:scaleB 1.5s ease-in-out infinite;-ms-animation:scaleB 1.5s ease-in-out infinite;animation:scaleB 1.5s ease-in-out infinite;background-color:#fff;left:33%}.dot.dot-c{-webkit-animation:scaleC 1.5s ease-in-out infinite;-moz-animation:scaleC 1.5s ease-in-out infinite;-ms-animation:scaleC 1.5s ease-in-out infinite;animation:scaleC 1.5s ease-in-out infinite;background-color:#fff;left:66%}.dot.dot-d{-webkit-animation:scaleD 1.5s ease-in-out infinite;-moz-animation:scaleD 1.5s ease-in-out infinite;-ms-animation:scaleD 1.5s ease-in-out infinite;animation:scaleD 1.5s ease-in-out infinite;background-color:#fff;left:100%}@-moz-keyframes scaleA{0%{transform:scale(1)}30%{transform:scale(1.5)}60%{transform:scale(1)}}@-webkit-keyframes scaleA{0%{transform:scale(1)}30%{transform:scale(1.5)}60%{transform:scale(1)}}@-o-keyframes scaleA{0%{transform:scale(1)}30%{transform:scale(1.5)}60%{transform:scale(1)}}@keyframes scaleA{0%{transform:scale(1)}30%{transform:scale(1.5)}60%{transform:scale(1)}}@-moz-keyframes scaleB{10%{transform:scale(1)}40%{transform:scale(1.5)}70%{transform:scale(1)}}@-webkit-keyframes scaleB{10%{transform:scale(1)}40%{transform:scale(1.5)}70%{transform:scale(1)}}@-o-keyframes scaleB{10%{transform:scale(1)}40%{transform:scale(1.5)}70%{transform:scale(1)}}@keyframes scaleB{10%{transform:scale(1)}40%{transform:scale(1.5)}70%{transform:scale(1)}}@-moz-keyframes scaleC{20%{transform:scale(1)}50%{transform:scale(1.5)}80%{transform:scale(1)}}@-webkit-keyframes scaleC{20%{transform:scale(1)}50%{transform:scale(1.5)}80%{transform:scale(1)}}@-o-keyframes scaleC{20%{transform:scale(1)}50%{transform:scale(1.5)}80%{transform:scale(1)}}@keyframes scaleC{20%{transform:scale(1)}50%{transform:scale(1.5)}80%{transform:scale(1)}}@-moz-keyframes scaleD{30%{transform:scale(1)}65%{transform:scale(1.5)}100%{transform:scale(1)}}@-webkit-keyframes scaleD{30%{transform:scale(1)}65%{transform:scale(1.5)}100%{transform:scale(1)}}@-o-keyframes scaleD{30%{transform:scale(1)}65%{transform:scale(1.5)}100%{transform:scale(1)}}@keyframes scaleD{30%{transform:scale(1)}65%{transform:scale(1.5)}100%{transform:scale(1)}}@-moz-keyframes expand{from{width:66px}to{width:100px;transform:translateX(-17px)}}@-webkit-keyframes expand{from{width:66px}to{width:100px;transform:translateX(-17px)}}@-o-keyframes expand{from{width:66px}to{width:100px;transform:translateX(-17px)}}@keyframes expand{from{width:66px}to{width:100px;transform:translateX(-17px)}}



</style>




// WEBPACK FOOTER //
// src/components/Project.vue